import { c as _c } from "react/compiler-runtime";
interface ErrorBlockProps {
  message?: string;
}
function ErrorBlock(t0) {
  const $ = _c(3);
  const {
    message
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <span className="text-base font-semibold md:text-lg">Error</span>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = message || "An unknown error occurred and the data could not be loaded.";
  let t3;
  if ($[1] !== t2) {
    t3 = <div className="rounded-lg p-8 w-full border border-destructive bg-destructive/20 text-destructive">{t1}<div className="bg-accent border border-accent-foreground/20 rounded-md text-xs md:text-sm p-2"><code>{t2}</code></div></div>;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  return t3;
}
export { ErrorBlock };